module.exports = __webpack_public_path__ + "img/acasia-bottom.d322c331.svg";